<template>
  <AppSection
    id="sms-history"
    :title="$getConst.pages.sms_configuration.sms_history_page_title"
    type="sub-section-1"
    :button="true"
    button-text="Export"
    :buttonIconSvg="$getConst.svgIcons.excel"
    button-variant="outline"
    @onClick="downloadFile"

  >
    <AppDataTable
      ref="commandLogsTable"
      :fields="fields"
      :end-point="endPoint"
    >
      <template v-slot:created_at="item">
        {{formatDate(item.data)}}
      </template>
    </AppDataTable>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../../components/common/sections/AppSection";
  import AppDataTable from "../../../../../components/common/table/AppDataTable";
  import {smsLogs} from "../../../../../api/scopes.api";
  import {formatDateByScope} from "../../../../../shared/services/date";

  export default {
    name: "index",
    components: {AppDataTable, AppSection},
    props: {
      scope_id: null,
    },
    data() {
      return {
        endPoint: null,
        fields: [
          {key: 'log_name', label: 'name', sortable: true, filterable: false},
          {key: 'description', sortable: true, filterable: false},
          {key: 'message_id', sortable: true, filterable: false},
          {key: 'message', sortable: true, filterable: false},
          {key: 'recipient_mobile', sortable: true, filterable: false},
          {key: 'credits', sortable: true, filterable: false},
          {key: 'user_id', sortable: true, filterable: false},
          {key: 'details', label: 'status', sortable: true, filterable: false},
          {key: 'created_at', label: 'send date', sortable: true, filterable: 'date'},
        ]
      }
    },
    methods: {
      downloadFile() {
        smsLogs(this.scope_id, {
            responseType: 'blob',
            headers: {
              'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const today = new Date();
            const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            const dateTime = date + ' ' + time;
            link.setAttribute('download', 'smsLogs-' + (this.scope ? this.scope.name : 'all') + '-' + dateTime + '.xlsx')
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
        });
      },
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date);
        return formatD;
      },
    },
    created() {
      this.endPoint = '/smsActivityLogs/' + this.scope_id;
    }
  }
</script>

<style scoped>

</style>
